<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loader"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>

    <Header />
    <b-card class="bCardGlobalXL">
    <b-row class="divSubtitulo m-1 mb-3">
      <b-col cols="6" md="10">
        <div>
          <p class="textoSubtitulo">Catálogo de tratamientos</p>
        </div>
      </b-col>
      <b-col cols="6" md="2">
        <div>
          <p style="text-align: end" class="textoSubtitulo">TX_01</p>
        </div>
      </b-col>
    </b-row>

    <div class="text-left mt-4">
      <p style="color: #0069A9; font-weight: 600;">Tratamiento "{{tratamiento.nombre}}"</p>
      <div class="d-flex justify-content-end" style="padding-left: 2%; padding-right: 2%;">
        <div v-for="(opt, index) in opcionesTabs" :key="index" style="">
          <div v-if="$localStorageService.can(opt.permiso)" @click="seleccionarTab(index)" class="mt-3 d-flex justify-content-center align-items-center" style=" min-width: 180px; height: 2.5em" :class="opcionTabSeleccionada == index ? 'tabOpciones seleccionado' : 'tabOpciones'" :title="opt.nombre">
            <p class="mt-3" :class="opcionTabSeleccionada == index ? 'tabTxtSeleccionado' : 'tabTxt'">
              {{ opt.nombre }}
            </p>
        </div>
        </div>
      </div>
      
      <p style="color: #17A2B8; font-size: .9em;">{{opcionesTabs[opcionTabSeleccionada].nombre}}</p>
      <b-row class="mt-5" v-if="opcionTabSeleccionada == 0 && $localStorageService.can('BO_35_tx_Datos_precios')">
        <b-col lg="8" class="scrollable-container-catalogo no-horizontal-scroll">
          <div style="font-size: .8em;">
            <p style="font-weight: 600;">Descripción: </p>
            <p v-if="tratamiento.descripcion != null && tratamiento.descripcion != ''">{{tratamiento.descripcion}}</p>
            <p v-else>Sin descripción</p>
          </div>
          <b-row>
            <b-col lg="4" class="mt-4">
              <b-form-group align="left">
                <label>Especialidad origen
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona la especialidad origen"
                      :options="especialidadArrayOrigen"
                      :reduce="(esp) => esp.value"
                      label="text"
                      v-model="tratamiento.idEspecialidadOrigen"
                      :state="tratamiento.idEspecialidadOrigen!= null"
                  />
                  <b-form-invalid-feedback :state="tratamiento.idEspecialidadOrigen != null">
                    Selecionar especialidad
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="mt-4">
              <b-form-group align="left">
                <label>Perfil laboral
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona el perfil laboral"
                      :options="especialidadArrayCrear"
                      :reduce="(esp) => esp.value"
                      label="text"
                      v-model="especialidadesArray"
                      multiple
                      :state="especialidadesArray != 0"
                  />
                  <b-form-invalid-feedback :state="especialidadesArray != 0">
                    Selecionar perfil laboral
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="mt-4">
              <b-form-group align="left">
                <label>Categoria
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona la categoria"
                      :options="categoriaArray"
                      :reduce="(cat) => cat.value"
                      label="text"
                      v-model="tratamiento.idCategoria"
                      :state="tratamiento.idCategoria != null"
                  />
                  <b-form-invalid-feedback :state="tratamiento.idCategoria != null">
                    Selecionar categoria
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="mt-4">
              <b-form-group align="left">
                <label>Riesgo
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona el riesgo"
                      :options="riesgoArray"
                      :reduce="(riesgo) => riesgo.value"
                      label="text"
                      v-model="tratamiento.idRiesgo"
                      :state="tratamiento.idRiesgo != null"
                  />
                  <b-form-invalid-feedback :state="tratamiento.idRiesgo!= null">
                    Selecionar riesgo
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="mt-4">
              <b-form-group align="left">
                <label>Sesiones Mínimas
                  <validacion/>
                </label>
                <b-form-select
                    class="redondeo"
                    style="width: 100%;"
                    v-model="tratamiento.minimoSessiones"
                    @change="crearArrayMin(tratamiento.minimoSessiones)"
                    :options="sesionesArray"
                    :state="tratamiento.minimoSessiones != null"
                ></b-form-select>
                <b-form-invalid-feedback :state="tratamiento.minimoSessiones != null">
                  Selecionar Sesiones minimas
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="mt-4">
              <b-form-group align="left">
                <label>Sesiones maximas
                </label>
                <b-input-group>
                  <b-form-select
                      class="redondeo"
                      style="width: 100%;"
                      v-model="tratamiento.maximoSesiones"
                      :options="sesionesArrayMax"
                      :disabled="tratamiento.minimoSessiones == null"
                      :state="tratamiento.maximoSesiones != null"
                      @input="limpiarLaboratorio()"
                  ></b-form-select>
                  <b-form-invalid-feedback :state="tratamiento.maximoSesiones != null">
                    Se debe colocar sesión máxima
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            
            <b-col lg="4" class="mt-4">
              <b-form-group align="left">
                <label>Tipo paciente
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      label="descripcion"
                      placeholder="Selecciona niño, adulto o mixto "
                      :options="adultoNinoArray"
                      :reduce="(variable) => variable.idDenticion"
                      v-model="tratamiento.idDenticion"
                      :state="tratamiento.idDenticion != null"
                  />
                  <b-form-invalid-feedback :state="tratamiento.idDenticion != null">
                    Se debe colocar opción
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="4" class="mt-4">
              <label>¿A que consentimiento aplica?
              </label>
              <b-input-group size="sm" class="mb-2">
                <v-select
                    class="redondeo"
                    style="width: 100%;"
                    placeholder="Selecciona el consentimiento"
                    v-model="tratamiento.consentimiento"
                    :options="consentimientoArray"
                    label="nombre"
                    multiple
                />
              </b-input-group>
            </b-col>
            <b-col lg="4" style="margin-top: 5%;">
              <b-form-checkbox v-model="tratamiento.complemento" switch>
                ¿Tiene complemento?
              </b-form-checkbox>
            </b-col>
            <b-col lg="4" style="margin-top: 5%;">
              <b-form-checkbox v-model="tratamiento.emergencia" switch>
                ¿Es tratamiento de emergencia?
              </b-form-checkbox>
            </b-col>

            <b-col lg="4" style="margin-top: 5%;">
              <b-form-checkbox v-model="tratamiento.aplicaEnvioComprasInvisalign" switch>
                ¿Genera order de compra alineadores?
              </b-form-checkbox>
              <b-form-group align="left" v-if="tratamiento.aplicaEnvioComprasInvisalign">
                <v-select
                    style="width: 100%;"
                    placeholder="Selecciona el proveedor de ERP "
                    :options="proveedoresERP"
                    label="text"
                    :reduce="(variable) => variable.value"
                    v-model="tratamiento.idProveedorERP"
                    :state="tratamiento.idProveedorERP != null"
                />
                <b-form-invalid-feedback :state="tratamiento.idProveedorERP != null">
                  Se debe colocar opción
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
<!--              LABORATORIOS <----------              -->
              <b-row>
                <b-col ><label>¿Pasa por laboratorio?</label></b-col>
                <b-col class="text-left"><b-form-checkbox v-model="tratamiento.pasaPorLaboratorio" switch
                                                          :disabled="tratamiento.maximoSesiones === 1 "
                /></b-col>
              </b-row>

              <div v-if="tratamiento.pasaPorLaboratorio">
                <b-row>
                  <b-col ><label>¿Habilitado para flujo digital?</label></b-col>
                  <b-col class="text-left"><b-form-checkbox v-model="tratamiento.flujoDigital" switch/></b-col>
                </b-row>

                <label>Variante del flujo físico </label><span style="color: red">*</span>
                <v-select
                    label="nombre"
                    :options="listaTipoFlujoFisico"
                    v-model="tratamiento.idTipoFlujoFisico"
                    style="width: 100%;"
                    placeholder="Selecciona una opción"
                    :reduce="(variable) => variable.idTipoFlujoFisico"
                    :clearable="false"
                />
                <br/>
                <b-row v-if=" tratamiento.idTipoFlujoFisico === 1 || tratamiento.idTipoFlujoFisico === 2 ">
                  <b-col ><label>¿Aplica para restauraciones implantosoportadas?</label></b-col>
                  <b-col class="text-left"><b-form-checkbox v-model="tratamiento.aplicaRestauraciones"/></b-col>
                </b-row>
                <b-row>
                  <b-col ><label>¿Puede tener provisional?</label></b-col>
                  <b-col class="text-left"><b-form-checkbox v-model="tratamiento.provisional"/></b-col>
                </b-row>
                <b-row>
                  <b-col ><label>¿Puede tener ajustes?</label></b-col>
                  <b-col class="text-left"><b-form-checkbox v-model="tratamiento.ajustes"/></b-col>
                </b-row>

              </div>

            </b-col>
            <b-col></b-col>
          </b-row>

        </b-col>
        <b-col lg="4" class="pt-4" style=" border: 1px solid #E1E1E1; border-radius: 15px; min-height: 30vh;">
          <p class="ml-1" style="font-weight: 600; font-size: .8em;">Clínicas asignadas</p>
          <div class="d-flex pl-1">
            <p class="mr-2 mt-1" style="font-size: .7em;">Seleccionar todas las clínicas</p>
            <b-form-checkbox
                v-model="todasClinicas"
                name="todasClinicas"
              >
            </b-form-checkbox>
          </div>
        
          <div class="d-flex justify-content-center" >
            <div class="barras d-flex" style="width: 80%;" >
              <b-form-input class="input-filter" v-model="filter" placeholder="Búsqueda por nombre de la clínica " type="text">
              </b-form-input>
              <b-button class="btn-extra-small" variant="info">
                <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px;"></em></span>
              </b-button>
            </div>
        </div>
          <div class="pl-4 pr-4 pt-3" style="min-height: 30em;">
            <b-table
            sticky-header
            :items="clinicas"
            :fields="fieldsClinicas"
            :filter="filter"
            :filter-included-fields="filterOn"
            v-bind="clinicas"

          >
            <template #cell(selected)="data">
              <b-form-checkbox
                v-model="data.item.selected"
                name="checkbox"
                :value="true"
              >
              </b-form-checkbox>
            </template>
          </b-table>
          </div>
        </b-col>
      </b-row>

      <div v-if="opcionTabSeleccionada == 1" class="mt-5">
        <b-row>
          <!-- pao -->
          <b-col lg="3">
            <b-form-group align="left">
              <label>¿En cuántas sesiones se paga el tratamiento?
                <validacion/>
              </label>
              <b-input-group size="sm">
                <b-form-select
                    class="redondeo"
                    style="width: 100%;"
                    placeholder="Selecciona el número de sesiones"
                    v-model="tratamiento.numeroSesionesPagar"
                    :options="sesionesArrayMinMax"
                    :disabled="
              tratamiento.minimoSessiones == null ||
              tratamiento.maximoSesiones == null
            "
                    :state="tratamiento.numeroSesionesPagar != null "
                ></b-form-select>
                <b-form-invalid-feedback :state="tratamiento.numeroSesionesPagar != null">
                  Se debe colocar opción
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group align="left">
              <label>¿En que sesiones se paga el tratamiento?
              </label>
              <b-input-group size="sm">
                <v-select
                    class="redondeo"
                    style="width: 100%;"
                    placeholder="Selecciona el número de sesiones"
                    :options="sesionesArrayMinMax"
                    :reduce="(esp) => esp.value"
                    label="text"
                    v-model="tratamiento.sesiones"
                    :disabled="
              tratamiento.minimoSessiones == null ||
              tratamiento.maximoSesiones == null
            "
                    :state="tratamiento.sesiones != 0 "
                    multiple
                ></v-select>
                <b-form-invalid-feedback :state="tratamiento.sesiones != 0">
                  Se debe colocar opción
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="3" >
            <b-form-group align="left">
              <label>Ponderacion (Bloque):
              </label>
              <b-input-group size="sm">
                <b-form-select
                    class="redondeo"
                    style="width: 100%;"
                    v-model="tratamiento.ponderacionBloque"
                    type="number"
                    :options="opciones"
                ></b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="3" class="mt-4">
            <b-form-checkbox switch v-model="aplicaTodasZonas">
              ¿Aplica en todas las zonas?
            </b-form-checkbox>
          </b-col>
          <b-col lg="3" class="mt-4">
            <b-form-checkbox
                        v-model="tratamiento.sinPlan"
                        switch
                        size="sm"
                    >
                      <label>¿Puede asignarse sin plan de tratamiento?</label>
                    </b-form-checkbox>
          </b-col>
        </b-row>
        <div class="mt-4">
          <div class="d-flex justify-content-between">
            <p style="font-size: .8em; font-weight: 600;">Precios por zona</p>
          <b-button class="boton-inv" style="margin-left: 1%" variant="primary" @click="agregarPrecioClinica" v-b-tooltip.hover title="Agregar precio especial por clínica">
            <em class="precio_especial icon-boton"></em>
        </b-button>
          </div>
        <div class="p-2 mt-2" style="border: 1px solid #90D3DD; border-radius: 15px;">
          <b-table
                        responsive
                        hover
                        :items="zonasPrecios"
                        :fields="fieldsZonas"
                        thead-tr-class="columnasTablaSinColor"
                        v-bind="zonasPrecios"
                        v-if="aplicaTodasZonas == false"
                    >
                      <template #cell(nombreZona)="data">
                        {{ data.value }}
                      </template>
  
                      <template v-slot:cell()="{ item, field: { key } }">
                <span v-if="key == 'precio'">
                  <b-form-input
                      v-model="item[key]"
                      :min="0"
                      step="1"
                      type="number"
                      @keydown="filterKey"
                      @input="filterInput"
                  ></b-form-input>
                </span>
  
                        <span v-else-if="key == 'precioExtranjero'">
                  <b-form-input
                      v-model="item[key]"
                      :min="0"
                      step="1"
                      type="number"
                      @keydown="filterKey"
                      @input="filterInput"
                  ></b-form-input>
                </span>
  
                        <span v-else>
                  <b-form-input
                      v-model="item[key]"
                      :min="0"
                      step="1"
                      type="number"
                  ></b-form-input>
                </span>
                      </template>
                    </b-table>
        </div>
        </div>

        <div class="mt-5" v-if="clinicasZonaPrecio.length > 0">
           <p style="font-size: .8em; font-weight: 600;">Precio especial por clínica</p>
        <div class="p-2 mt-2" style="border: 1px solid #90D3DD; border-radius: 15px;">
          <validation-observer ref="observer" v-slot="{ handleSubmit }" >
            <b-form @submit.stop.prevent="handleSubmit(actualizarTrt)">
              <b-table
                  responsive
                  hover
                  :items="clinicasZonaPrecio"
                  :fields="fieldsZonasPrecioClinica"
                  thead-tr-class="columnasTablaSinColor"
                  :filter="filtro"
                  id="clinicas-zona-precios"
              >
                <template #cell(idClinica)="{ item, field: { key } }">
                  <validation-provider
                      :name="key"
                      :rules="{ required: true }"
                      v-slot="validationContext"
                  >
                    <v-select
                        :options="clinicas"
                        :reduce="(c) => c.idClinica"
                        label="nombreConZona"
                        v-model="item[key]"
                    >
                    </v-select>
                    <validacion
                        :texto="
                        validationContext.errors[0]
                          ? validationContext.errors[0]
                          : ''
                      "
                    ></validacion>
                  </validation-provider>
                </template>
  
                <template v-slot:cell()="{ item, field: { key } }">
                  <validation-provider
                      :name="key"
                      rules="required"
                      v-slot="validationContext"
                  >
                    <b-form-input
                        autocomplete="off"
                        v-model="item[key]"
                        :min="0"
                        @keypress="$onlyNumber"
                        @keyup="$onlyNumber"
                        @paste="$onlyNumber"
                    ></b-form-input>
                    <validacion
                        :texto="
                        validationContext.errors[0]
                          ? validationContext.errors[0]
                          : ''
                      "
                    ></validacion>
                  </validation-provider>
                </template>
  
                <template #cell(Acciones)="row">
                  <b-button
                      title="Eliminar precio clínica"
                      variant="outline-danger"
                      size="sm"
                      @click="eliminarClinicaZonaPrecio(row.item)"
                  ><b-icon icon="trash-fill"></b-icon
                  ></b-button>
                </template>
              </b-table>
            </b-form>
          </validation-observer>
        </div>
        </div>
          <b-button
            v-if="!$localStorageService.can('BO_35_tx_tiemposugerido')"
              variant="primary"
              class="botonesAzulFuerte"
              :disabled="
                especialidadesArray.length == 0 ||
                tratamiento.idCategoria == '' ||
                tratamiento.idRiesgo == '' ||
                tratamiento.minimoSessiones == '' ||
                tratamiento.maximoSesiones == '' ||
                tratamiento.idEspecialidadOrigen == null ||
                tratamiento.sesiones == '' ||
                btnDisabled == true
              "
              @click="actualizarTrt"
          >
            <span>Guardar</span>
          </b-button>
      </div>
      <div class="text-center" v-if="opcionTabSeleccionada == 2">
        <b-row>
          <b-col lg="3">
            <b-form-checkbox switch v-model="tratamiento.varianteTiempo">
              ¿Tiene variante de tiempo?
            </b-form-checkbox>
          </b-col>
          <b-col lg=3>
            <b-form-group align="left">
              <label>Tiempo mínimo por tratamiento
                <validacion/>
              </label>
              <br>
              <span style="font-size: 12px">Duración minutos</span>
              <b-input-group size="sm" class="mb-2"
                             style="width: 80%;">
                <b-input-group-prepend>
                  <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoMinimoTratamiento = tratamiento.tiempoMinimoTratamiento-intervalo"  :disabled="!(tratamiento.tiempoMinimoTratamiento > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                </b-input-group-prepend>
                <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoMinimoTratamiento"></b-form-input>
                <b-input-group-append>
                  <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoMinimoTratamiento = intervalo+tratamiento.tiempoMinimoTratamiento"  :disabled="!(tratamiento.tiempoMinimoTratamiento === numeroMinimo || tratamiento.tiempoMinimoTratamiento < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                </b-input-group-append>
                <b-form-invalid-feedback :state="tratamiento.tiempoMinimoTratamiento > numeroMinimo">
                  Se debe colocar duración minutos
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group align="left">
              <label>Tiempo sugerido por tratamiento
                <validacion/>
              </label>
              <br>
              <span style="font-size: 12px">Duración minutos</span>
              <b-input-group size="sm" class="mb-2"
                             style="width: 80%;">
                <b-input-group-prepend>
                  <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoSugeridoTratamiento = tratamiento.tiempoSugeridoTratamiento-intervalo"  :disabled="!(tratamiento.tiempoSugeridoTratamiento > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                </b-input-group-prepend>
                <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoSugeridoTratamiento"></b-form-input>
                <b-input-group-append>
                  <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoSugeridoTratamiento = intervalo+tratamiento.tiempoSugeridoTratamiento"  :disabled="!(tratamiento.tiempoSugeridoTratamiento === numeroMinimo || tratamiento.tiempoSugeridoTratamiento < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                </b-input-group-append>
                <b-form-invalid-feedback :state="tratamiento.tiempoSugeridoTratamiento > numeroMinimo">
                  Se debe colocar duración minutos
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group align="left">
              <label>Tiempo máximo por tratamiento
                <validacion/>
              </label>
              <br>
              <span style="font-size: 12px">Duración minutos</span>
              <b-input-group size="sm" class="mb-2"
                             style="width: 80%;">
                <b-input-group-prepend>
                  <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoMaximoTratamiento = tratamiento.tiempoMaximoTratamiento -intervalo"  :disabled="!(tratamiento.tiempoMaximoTratamiento  > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                </b-input-group-prepend>
                <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoMaximoTratamiento "></b-form-input>
                <b-input-group-append>
                  <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoMaximoTratamiento  = intervalo+tratamiento.tiempoMaximoTratamiento "  :disabled="!(tratamiento.tiempoMaximoTratamiento  === numeroMinimo || tratamiento.tiempoMaximoTratamiento  < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                </b-input-group-append>
                <b-form-invalid-feedback :state="tratamiento.tiempoMaximoTratamiento  > numeroMinimo">
                  Se debe colocar duración minutos
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="tratamiento.varianteTiempo">
          <b-col class="col-12 col-sm-12 col-md-4">
            <div>
              <b-col cols="12" class="contenedorTablaSinColor" style="height: 80vh; !important;">
                <br>
                <b-row>
                  <b-col>
                    <b-form-group align="left">
                      <label>  <span style="color: #0c69a7; font-weight: 600">Variaciones de tiempo</span>
                        <validacion/>
                      </label>
                      <b-input-group size="sm" class="mb-2">
                        <b-form-input
                            class="redondeo"
                            id="idNombre"
                            placeholder="Ingrese el nombre variacion de tiempo"
                            v-model="tratamiento.variacionesTiempo"
                            :state="tratamiento.variacionesTiempo != null && tratamiento.variacionesTiempo != '' "
                        ></b-form-input>
                        <b-form-invalid-feedback :state="tratamiento.variacionesTiempo != null && tratamiento.variacionesTiempo != ''">
                          Se debe colocar el nombre variacion de tiempo
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="ml-2 mr-2">
                    <b-form-group align="left">
                      <label> <span style="color: #0c69a7; font-weight: 600">Opciones</span>
                        <validacion/>
                      </label>
                      <b-input-group size="sm" class="mb-2 contenedorInputSinColor variacion-opciones" >
                        <b-form-input
                            class="redondeo m-1"
                            id="opcion"
                            placeholder="Nueva respuesta"
                            v-model="nuevaOpcion.descripcionOpcion"
                        ></b-form-input>
                        <em class="mas_azul_svg sm mr-2 ml-2" @click="agregarOpcion()"></em>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-for="(opcion, index) in tratamiento.listaOpcionesVariacionesTiempo" :key="index" class="ml-2 mr-2 mt-2 contenedorInputSinColor">
                  <b-col class="text-left mt-2">
                    <p>{{opcion.descripcionOpcion}}</p>
                  </b-col>
                  <b-col class="text-end mt-2">
                    <em v-if="!opcion.editar" class="editar-naranja-svg ml-2 " v-b-tooltip.hover
                        title="Editar" @click="editarActivo(opcion, index)"></em>
                    <em v-if="!opcion.registroActivo" class="desactivo-rojo-svg ml-2 " v-b-tooltip.hover
                        title="Desactivado" @click="activarDesactivarOpcion(true, index)"></em>
                    <em  v-else class="activo-verde-svg ml-2" v-b-tooltip.hover
                         title="Activo"   @click="activarDesactivarOpcion(false, index)"></em>
                  </b-col>
                </b-row>
              </b-col>
            </div>
          </b-col>
          <b-col class="col-12 col-sm-12 col-md-4">
            <div>
              <b-col cols="12" class="contenedorTablaSinColor" style="height: 80vh; !important;">
                <br>
                <b-col class="mb-2">
                  <span style="color: #0c69a7; font-weight: 600">Información de ayuda al anfitrión</span>
                  <validacion/>
                </b-col>
                <div>
                  <VueEditor v-model="tratamiento.infoAyudaAnfitrion"></VueEditor>
                </div>
              </b-col>
            </div>
          </b-col>
        </b-row>
        <b-button
                variant="primary"
                class="botonesAzulFuerte mt-5"
                :disabled="
                especialidadesArray.length == 0 ||
                tratamiento.idCategoria == '' ||
                tratamiento.idDenticion == null ||
                tratamiento.idRiesgo == '' ||
                tratamiento.minimoSessiones == '' ||
                tratamiento.maximoSesiones == '' ||
                tratamiento.idEspecialidadOrigen == null ||
                tratamiento.sesiones == '' ||
                btnDisabled == true || tratamiento.idTipoFlujoFisico == null
                "
                @click="actualizarTrt"
            >
              <span>Guardar</span>
            </b-button>
      </div>

    </div>

   </b-card>
    
   
    <b-modal id="modal-1" title="Asignar Clínicas/Estados" hide-footer>
      <b-input-group size="sm">
        <b-form-input
          v-model="filter"
          type="search"
          id="filterInput"
          placeholder="Buscar"
        ></b-form-input>
        <b-input-group-append>
          <b-button :disabled="!filter" @click="filter = ''">Limpiar </b-button>
        </b-input-group-append>
      </b-input-group>
      <div class="botonesSeleccion">
        <b-button size="sm" @click="selectAllRows" variant="outline-primary"
          >Seleccionar todo</b-button
        >
        <b-button
          size="sm"
          @click="clearSelected"
          variant="outline-danger"
          style="margin-left: 10px"
          >Inactivar todo</b-button
        >
      </div>
      <b-table
        responsive="sm"
        sticky-header
        :items="clinicas"
        :fields="fieldsClinicas"
        :filter="filter"
        :filter-included-fields="filterOn"
        v-bind="clinicas"
        thead-tr-class="columnas"
      >
        <template #cell(selected)="data">
          <b-form-checkbox
            v-model="data.item.selected"
            name="checkbox"
            :value="true"
          >
          </b-form-checkbox>
        </template>
      </b-table>
      <div class="btnsBottom">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="$bvModal.hide('modal-1')"
          >Guardar</b-button
        >

        <b-button
          style="margin-left: 10px"
          variant="outline-danger"
          size="sm"
          @click="cerrarModal"
          >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import {VueEditor} from "vue2-editor";
export default {
  name: "Tratamiento",
  props: {
    msg: String,
  },
  components: {
    Header,
    VueEditor
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    todasClinicas: false,
    arrayZonas: [],
    opcionTabSeleccionada: 0,
    opcionesTabs: [
        {
          nombre: "Datos generales",
          permiso: 'BO_35_tx_Datos_precios'
        },
        {
          nombre: "Precios y comisiones",
          permiso: 'BO_35_tx_Datos_precios'
        },
        {
          nombre: "Configuración",
          permiso: 'BO_35_tx_tiemposugerido'
      },
      ],
    especialidadesArray: [],
    especialidadArrayCrear: [],
    zonasPrecios:[],
    laboratorio: false,
    banderaNombre: false,
    especialidadOriginal: null,
    especialidadesArrayGet: [],
    loading: true,
    id: null,
    tratamiento: {
      descripcion: null,
      fechaAlta: null,
      fechaModificacion: null,
      idCategoria: null,
      especialidades: [],
      sesiones: [],
      adultoNinoArray: [],
      idMaterial: null,
      idRiesgo: null,
      idTratamiento: null,
      idUsuarioAlta: null,
      idUsuarioModificacion: null,
      idDenticion: null,
      maximoSesiones: null,
      minimoSessiones: null,
      monitoreado: true,
      nombre: null,
      nombreAbreviado: null,
      nombreCategoria: null,
      nombreEspecialidad: null,
      nombreMaterial: null,
      nombreRiesgo: null,
      registroActivo: true,
      variasSesiones: true,
      avptSdi: false,
      avpt: false,
      sinPoh: false,
      redKobe: false,
      cantidad: false,
      hdx: false,
      bip: false,
      bonoReferencia: false,
      sinPlan: false,
      ligadoOd: false,
      todosDientes: false,
      numeroSesionesPagar: null,
      ponderacion: 1,
      complemento: false,
      costoTratamiento: 0,
      descripcionPx: null,
      emergencia: false,
      varianteTiempo: false,
      tiempoMinimoTratamiento: 0,
      tiempoSugeridoTratamiento:0,
      tiempoMaximoTratamiento:0,
      variacionesTiempo: null,
      listaOpcionesVariacionesTiempo: [],
      infoAyudaAnfitrion: null,
      tipoGuardar:1,
      pasaPorLaboratorio: false,
      flujoDigital: false,
      idTipoFlujoFisico: null,
      provisional: false,
      ajustes: false,
      aplicaRestauraciones: false,

    },
    especialidadArray: null,
    consentimientoArray: [],
    consentimientosArrayGet: [],
    especialidadArrayOrigen: [],
    riesgoArray: [
      {
        value: 1,
        text: "BAJO",
      },
      {
        value: 2,
        text: "MEDIO",
      },
      {
        value: 3,
        text: "ALTO",
      },
      {
        value: 4,
        text: "MUY ALTO",
      },
    ],
    adultoNinoArray: [
      {
        idDenticion: null,
        descripcion: "",
      },
    ],
    sesionesArray: [],
    sesionesArrayMax: [],
    sesionesArrayMinMax: [],
    ponderacionArray: [],
    categoriaArray: [],
    proveedoresERP: [],
    arrayZonaTodas: [
      {
        bonoIndividualOg: null,
        bonoTrimestral: null,
        comisionBaseEspecialistas: null,
        comisionBaseOG: null,
        comisionMasBonoEspecialistas: null,
        idZona: 10,
        precio: null,
        precioExtranjero: null,
        registroActivo: true,
        nombreZona: "TODAS",
      },
    ],
    aplicaTodasZonas: false,
    fieldsZonas: [
      {
        key: "nombreZona",
        label: "Zonas",
      },
      {
        key: "precio",
        label: "Precio",
      },
      {
        key: "precioExtranjero",
        label: "Precio Extranjero",
      },
      {
        key: "bonoIndividualOg",
        label: "Bono individual OG's",
      },
      {
        key: "comisionBaseEspecialistas",
        label: "Comisión base especialistas",
      },
      {
        key: "comisionMasBonoEspecialistas",
        label: "Comisión más bono especialistas",
      },
      {
        key: "bonoTrimestral",
        label: "Bono trimestral OG's",
      },
      {
        key: "comisionBaseOG",
        label: "Comisión base OG's",
      },
      {
        key: "comisionMultiplicador",
        label: "comision bloque bip",
      },
    ],
    filtro: null,
    fieldsZonasPrecioClinica: [
      {
        key: "idClinica",
        label: "Clínica",
        sortable: true,
        tdClass: "clinica-zona-precio",
      },
      {
        key: "precio",
        label: "Precio",
      },
      {
        key: "precioExtranjero",
        label: "Precio Extranjero",
      },
      {
        key: "bonoIndividualOg",
        label: "Bono individual OG's",
      },
      {
        key: "comisionBaseEspecialistas",
        label: "Comisión base especialistas",
      },
      {
        key: "comisionMasBonoEspecialistas",
        label: "Comisión más bono especialistas",
      },
      {
        key: "bonoTrimestral",
        label: "Bono trimestral OG's",
      },
      {
        key: "comisionBaseOG",
        label: "Comisión base OG's",
      },
      {
        key: "comisionMultiplicador",
        label: "Comisión bloque BIP",
      },
      "Acciones",
    ],
    clinicas: [],
    clinicasZonaPrecio: [],
    fieldsClinicas: [
      { key: "idClinica", label: "ID", sortable: true, sortDirection: "desc" },
      {
        key: "strNombre",
        label: "Nombre",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "selected",
        label: "Selección",
      },
    ],
    filter: null,
    filterOn: [],
    selectMode: "multi",

    loadingClinicas: false,
    loadingCategorias: false,
    loadingProveedoresERP: false,
    loadingEspecialidades: false,
    loadingTratamientos: false,
    loadingGuardar: false,
    estatusCategoria: [],
    opciones: [1,2,3,4,5,6,7,8,9,0.5],
    intervalo: 15,
    numeroMinimo: 0,
    numeroMaximo:480,
    nuevaOpcion:{idOpcion: null, descripcionOpcion: "", registroActivo: true},
    listaTipoFlujoFisico: [],
  }),

  methods: {
    limpiarLaboratorio(){
      if(this.tratamiento.maximoSesiones === 1){
            this.tratamiento.pasaPorLaboratorio = false;
            this.tratamiento.flujoDigital = false;
            this.tratamiento.idTipoFlujoFisico = null;
            this.tratamiento.provisional = false;
            this.tratamiento.ajustes = false;
            this.tratamiento.aplicaRestauraciones = false;
      }
    },
    obtenerTiposFlujoFisico(){
      this.$http.get(this.$api + "labs/listaFlujoFisico")
          .then((response) => {
            this.listaTipoFlujoFisico = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() =>{});
    },
    llenarZonas() {
      this.$http
        .get(this.$api + "catalogos/listaPrecios")
        .then((response) => {
          if (response.status === 200) {
            // this.arrayZonas = response.data.data;

            this.arrayZonas = response.data.data.map(function (el) {
              var o = Object.assign({}, el);
              o.precio = null;
              o.precioExtranjero = null;
              o.bonoIndividualOg = null;
              o.comisionBaseEspecialistas = null;
              o.comisionMasBonoEspecialistas = null;
              o.bonoTrimestral = null;
              o.comisionBaseOG = null;
              return o;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    seleccionarTab(index) {
      this.opcionTabSeleccionada = index;
    },
    obtenerTipoDenticion() {
      this.$http
        .get(this.$api + "catalogos/padecimientos/obtener/tipo/denticion")
        .then((r) => {
          if (r.data.data) {
            this.adultoNinoArray = r.data.data;
          }
        });
    },
    checarNombre(nombre) {
      if (nombre.match(/^\s+$/) === null) {
        this.banderaNombre = false;
      } else {
        this.banderaNombre = true;
      }
    },
    filterKey(e) {
      const key = e.key;

      if (key === ".") return e.preventDefault();

      if (key === "e") return e.preventDefault();
    },

    filterInput(e) {
      if (e.target != undefined) {
        e.target.value = e.target.value.replace(/[^0-9]+/g, "");
      }
    },
    cerrarModal() {
      this.$bvModal.hide("modal-1");
    },
    selectAllRows(todasClinicas) {
      if(todasClinicas){
        this.clinicas.forEach((itm) => {
        itm.selected = true;
      });
      }else{
        this.clinicas.forEach((itm) => {
        itm.selected = false;
      });
      }
    },
    clearSelected() {
      this.clinicas.forEach((itm) => {
        itm.selected = false;
      });
    },
    actualizarTrt() {

      if (this.tratamiento.aplicaEnvioComprasInvisalign != null
          && this.tratamiento.aplicaEnvioComprasInvisalign
          && (this.tratamiento.idProveedorERP == null
              || this.tratamiento.idProveedorERP == 0)) {
        this.$swal.fire({
          icon: "error",
          text: "Debes seleccionar un proveeddor de ERP en la pestaña 'DATOS GENERALES'",
        });
        return;
      }

      if(this.$localStorageService.can('BO_35_tx_Datos_precios') && this.$localStorageService.can('BO_35_tx_tiemposugerido')){
        this.tratamiento.tipoGuardar = 1;
      }else if (this.$localStorageService.can('BO_35_tx_Datos_precios')){
        this.tratamiento.tipoGuardar = 2;
      }else if (this.$localStorageService.can('BO_35_tx_tiemposugerido')){
        this.tratamiento.tipoGuardar = 3;
      }
      
      if (this.tratamiento.zonaprecios != null) {
        this.tratamiento.zonaprecios.forEach((element) => {

          if (
              element.comisionMultiplicador == null ||
              element.comisionMultiplicador == "" ||
              element.comisionMultiplicador == "0" ||
              element.comisionMultiplicador == 0
          ) {
            element.comisionMultiplicador = 0;
          }

          if (
            element.precio == null ||
            element.precio == "" ||
            element.precio == "0" ||
            element.precio == 0
          ) {
            element.precio = 0;
          }
          if (
            element.precioExtranjero == null ||
            element.precioExtranjero == ""
          ) {
            element.precioExtranjero = 0;
          }
          if (
            element.bonoIndividualOg == null ||
            element.bonoIndividualOg == ""
          ) {
            element.bonoIndividualOg = 0;
          }
          if (element.bonoTrimestral == null || element.bonoTrimestral == "") {
            element.bonoTrimestral = 0;
          }
          if (
            element.comisionBaseEspecialistas == null ||
            element.comisionBaseEspecialistas == ""
          ) {
            element.comisionBaseEspecialistas = 0;
          }
          if (element.comisionBaseOG == null || element.comisionBaseOG == "") {
            element.comisionBaseOG = 0;
          }
          if (
            element.comisionMasBonoEspecialistas == null ||
            element.comisionMasBonoEspecialistas == ""
          ) {
            element.comisionMasBonoEspecialistas = 0;
          }
        });
      }

      this.tratamiento.costoTratamiento =
        this.tratamiento.costoTratamiento == null ||
        this.tratamiento.costoTratamiento === "" ||
        this.tratamiento.length === 0
          ? 0
          : this.tratamiento.costoTratamiento;

      this.tratamiento.especialidades = this.especialidadesArray.map(
        (it) => {
          return {
            idEspecialidad: it,
            nombreEspecialiadString: "vacio",
          };
        }
      );

      var ArrayClinicasSeleccionadas = this.clinicas.filter(function (item) {
        return item.selected == true;
      });

      this.tratamiento.clinicas = ArrayClinicasSeleccionadas;

      this.tratamiento.clincasZonaPrecio = this.clinicasZonaPrecio;

      let clinicaRepetida = false;
      this.clinicasZonaPrecio.forEach((it) => {
        const vecesClinica = this.clinicasZonaPrecio.filter(
          (zp) => zp.idClinica === it.idClinica
        ).length;
        if (vecesClinica > 1) {
          const clinicaRep = this.clinicas.filter(
            (c) => c.idClinica === it.idClinica
          );
          this.$swal.fire({
            icon: "warning",
            text:
              "No puedes tener mas de un precio para la clínica " +
              clinicaRep[0].strNombre,
          });
          clinicaRepetida = true;
        }
      });

      if (clinicaRepetida) {
        return;
      }

      if (ArrayClinicasSeleccionadas.length == 0) {
        this.loadingGuardar = false;
        this.$swal.fire({
          icon: "error",
          text: "Falta seleccionar una clínica para el tratamiento",
        });

      }else if (this.tratamiento.varianteTiempo && this.tratamiento.listaOpcionesVariacionesTiempo.length == 0) {
        this.$swal.fire({
          icon: "info",
          text: "Falta agregar opciones en variacion de tiempo",
        });
      }else if (this.tratamiento.varianteTiempo && (this.tratamiento.infoAyudaAnfitrion  == "" ||
          this.tratamiento.infoAyudaAnfitrion  == null
          || this.nuevaOpcion.descripcionOpcion.trim() !== "")) {
        this.$swal.fire({
          icon: "info",
          text: "Falta agregar información de ayuda al anfitrión",
        });
      } else {

        this.loadingGuardar = false;
        this.$swal.fire({
          title: "¿Estás seguro de actualizar el tratamiento?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {

            this.tratamiento.idUsuarioModificacion =
              this.$localStorageService.getIdUsuario();

            this.loadingGuardar = true;
            this.$http
              .put(
                this.$api + "tratamientos/actualizarTratamientoDetalle",
                this.tratamiento
              )
              .then((response) => {
                if (response.status === 200) {
                  const message = response.data.message
                    ? response.data.message
                    : "Se actualizó correctamente el registro";

                  this.idDenticion = this.tratamiento.adultoNinoArray;
                  this.loadingGuardar = false;
                  this.$swal({
                    icon: "success",
                    title: message,
                    showConfirmButton: false,
                    timer: 2500,
                  });
                  this.$router.push({ name: "tratamientos" });
                }
              })
              .catch((error) => {
                this.loadingGuardar = false;
                const message = error.response.data.message
                  ? error.response.data.message
                  : "Error al crear el registro";

                this.$swal({
                  icon: "error",
                  title: message,
                  showConfirmButton: false,
                });
              });
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        });
      }
    },
    getTratamiento(id) {
      this.loadingTratamientos = true;
      this.tratamiento = null;
      this.clinicasZonaPrecio = [];
      const parametros = {idTratamiento: id}
      this.$http
        .post(this.$api + "tratamientos/detalleTratamiento", parametros)
        .then((response) => {
          if (response.status === 200) {
            this.tratamiento = response.data.data;
            if (Array.isArray(this.tratamiento.especialidades)) {
              this.tratamiento.especialidades.forEach((item) => {
                this.especialidadesArray.push(item["idEspecialidad"]);
              });
            }
           
            if (Array.isArray(this.tratamiento.clinicas)) {
              this.tratamiento.clinicas.forEach((item) => {
                this.clinicas.forEach((itm) => {
                  if (item.idClinica == itm.idClinica) {
                    itm.selected = true;
                  }
                });
              });
            }
            this.zonasPrecios=[];
            
            if(this.tratamiento.zonaprecios != null){
              this.tratamiento.zonaprecios.forEach((zona)=>{
              this.zonasPrecios.push(zona);
            });
            }else{
              
              this.arrayZonas.forEach((element) => {
                if (
                  element.precio == null ||
                  element.precio == "" ||
                  element.precio == "0" ||
                  element.precio == 0
                ) {
                  element.precio = 0;
                }
                if (
                  element.precioExtranjero == null ||
                  element.precioExtranjero == ""
                ) {
                  element.precioExtranjero = 0;
                }
                if (
                  element.bonoIndividualOg == null ||
                  element.bonoIndividualOg == ""
                ) {
                  element.bonoIndividualOg = 0;
                }
                if (element.bonoTrimestral == null || element.bonoTrimestral == "") {
                  element.bonoTrimestral = 0;
                }
                if (
                  element.comisionBaseEspecialistas == null ||
                  element.comisionBaseEspecialistas == ""
                ) {
                  element.comisionBaseEspecialistas = 0;
                }
                if (element.comisionBaseOG == null || element.comisionBaseOG == "") {
                  element.comisionBaseOG = 0;
                }
                if (
                  element.comisionMasBonoEspecialistas == null ||
                  element.comisionMasBonoEspecialistas == ""
                ) {
                  element.comisionMasBonoEspecialistas = 0;
                }
              });

              this.zonasPrecios = this.arrayZonas;
              this.tratamiento.zonaprecios = this.zonasPrecios
            }

            this.clinicasZonaPrecio = [];
            if (
              this.tratamiento.clincasZonaPrecio !== undefined &&
              this.tratamiento.clincasZonaPrecio !== null
            ) {
              this.clinicasZonaPrecio = this.tratamiento.clincasZonaPrecio;
            }
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => (this.loadingTratamientos = false));
    },
    agregarPrecioClinica() {
      this.clinicasZonaPrecio.push({
        idClinica: undefined,
        idZona: undefined,
        nombreZona: undefined,
        strNombre: undefined,
        precio: undefined,
        precioExtranjero: undefined,
        bonoIndividualOg: undefined,
        comisionBaseEspecialistas: undefined,
        comisionMasBonoEspecialistas: undefined,
        bonoTrimestral: undefined,
        comisionBaseOG: undefined,
      });
    },
    eliminarClinicaZonaPrecio(item) {
      const indiceEliminar = this.clinicasZonaPrecio.indexOf(item);
      this.clinicasZonaPrecio.splice(indiceEliminar, 1);
    },
    llenarProveedoresERP() {
      this.loadingProveedoresERP = true;
      this.proveedoresERP = [];
      this.$http
          .get(this.$api + "proveedoreERP/obtenerProveedoresERP")
          .then((response) => {
            if (response.status === 200) {
              var arrayRespuesta = response.data.data.map((it) => {
                return {
                  value: it.idProveedorERP,
                  text: it.descripcion,
                };
              });
              this.proveedoresERP = arrayRespuesta.filter(function (item) {
                return item.idProveedorERP != 0;
              });
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.loadingProveedoresERP = false;
          });
    },
    llenarEspecialidades() {
      this.$http
          .get(this.$api + "catalogos/obtenerEspecialidades")
          .then((response) => {
            if (response.status === 200) {
              var arrayRespuesta = response.data.data.map((it) => {
                return {
                  value: it.id,
                  text: it.especialidad,
                  color: it.color,
                  especialidadOrigen: it.especialidadOrigen,
                };
              });
              this.especialidadArray = arrayRespuesta.filter(function (item) {
                return item.value != 0;
              });

              this.especialidadArrayOrigen = arrayRespuesta.filter(function (
                  item
              ) {
                return item.especialidadOrigen;
              });

              this.especialidadArrayCrear = arrayRespuesta.filter(function (
                  item
              ) {
                return item.value != 0;
              });

              this.especialidadArray.push({ value: 0, text: "TODAS" });
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    llenarCategorias() {
      this.loadingCategorias = true;
      this.$http
        .get(this.$api + "catalogos/listaCategorias")
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data.map((it) => {
              return {
                value: it.idCategoria,
                text: it.descripcion,
              };
            });
            this.categoriaArray = arrayRespuesta.filter(function (item) {
              return item.value != 0;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loadingCategorias = false;
        });
    },
    obtenerCategorias() {
      this.$http
        .get(this.$api + "catalogos/obtenerListaCategorias")
        .then((response) => {
          this.categoriaTratamientoArray = response.data.data;
          const arrayRespuesta = response.data.data;
          this.categoriasTratamiento = arrayRespuesta;
        });
    },
    obtenerEstatusCategorias() {
      this.$http
        .get(this.$api + "catalogos/obtenerEstatusCategorias")
        .then((response) => {
          const arrayRespuesta = response.data.data;
          this.estatusCategoria = arrayRespuesta;
        })
        .catch((error) => {
          console.error("error", error);
        });
    },

    obtenerSubcategorias(idCategoriaTratamiento) {
      let subcat = this.categoriaTratamientoArray.filter(function (item) {
        return item.idCategoria === idCategoriaTratamiento;
      });
      let subcat2 = subcat[0].subCategorias.map((it) => {
        return {
          value: it.idSubcategoriaTratamiento,
          text: it.nombreSubcategoria,
        };
      });

      this.subcategoriasTratamiento = subcat2;
    },

    llenarClinicas() {
      this.loadingClinicas = true;
      this.$http
        .post(this.$api + "catalogos/listaClinicasActivas", {})
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data.map((it) => {
              return {
                idClinica: it.idClinica,
                strNombre: it.strNombre,
                selected: false,
                zonaNombre: it.zonaPrecioNombre,
              };
            });
            this.clinicas = arrayRespuesta.filter(function (item) {
              return item.idClinica != 0;
            });

            this.clinicas.forEach(
              (it) => (it.nombreConZona = it.strNombre + "-" + it.zonaNombre)
            );

          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loadingClinicas = false;
          this.getTratamiento(this.id);
        });
    },
    llenarPonderacion() {
      for (let index = 0; index <= 10; index++) {
        this.ponderacionArray.push({
          value: index,
          text: index,
        });
      }
    },
    crearArrayMin(i) {
      this.sesionesArrayMax = [];
      this.tratamiento.maximoSesiones = null;
      for (let index = i; index < 20; index++) {
        this.sesionesArrayMax.push({
          value: index,
          text: index,
        });
      }
    },
    crearArrayMinMax(i, x) {
      this.sesionesArrayMinMax = [];
      for (let index = 1; index <= x; index++) {
        this.sesionesArrayMinMax.push({
          value: index,
          text: index,
        });
      }
    },
    llenarSesiones() {
      for (let index = 1; index < 20; index++) {
        this.sesionesArray.push({
          value: index,
          text: index,
        });
        this.sesionesArrayMax.push({
          value: index,
          text: index,
        });
        this.sesionesArrayMinMax.push({
          value: index,
          text: index,
        });
      }
    },
    transformZonas(valor, keyObj) {
      this.tratamiento.zonaprecios.forEach((element) => {
        element[keyObj] = valor;
      });
    },
    /*listarConsentimientos() {
      this.$http
        .get(this.$api + "consentimientos/obtener/consentimiento")
        .then((response) => {
          if (response.data.data) {
            var arrayC = response.data.data.map((c) => {
              return {
                idConsentimiento: c.idConsentimiento,
                nombre: c.nombre,
              };
            });
            this.consentimientoArray = arrayC.filter(function (item) {
              return item.idConsentimiento != 0;
            });
            this.consentimientoArray.forEach((it) => it.idConsentimiento);
          }
        });
    },*/
    agregarOpcion(){
      
      if(this.nuevaOpcion.descripcionOpcion.trim() !== "" && this.nuevaOpcion.descripcionOpcion != "" && this.nuevaOpcion.descripcionOpcion != null) {
        if(this.tratamiento.listaOpcionesVariacionesTiempo === null){
          this.tratamiento.listaOpcionesVariacionesTiempo = [];
        }
        this.tratamiento.listaOpcionesVariacionesTiempo.push(this.nuevaOpcion);
        this.nuevaOpcion = {idOpcion: null, descripcionOpcion: "", registroActivo: true};
        this.tratamiento.listaOpcionesVariacionesTiempo.forEach(o=>{
          o['editar'] = false;
        });
      }
    },
    editarActivo(opcion, index){
      this.nuevaOpcion = opcion;
      this.tratamiento.listaOpcionesVariacionesTiempo.splice(index,1);
      this.tratamiento.listaOpcionesVariacionesTiempo.forEach(o=>{
        o['editar'] = true;
      });
    },
    activarDesactivarOpcion(valor, index){
      this.tratamiento.listaOpcionesVariacionesTiempo[index].registroActivo = valor;
    }
  },
  watch: {
    "todasClinicas": function (val) {
      if (val != null) {
        this.selectAllRows(val);
      }
    },
    "tratamiento.nombre": function (val) {
      if (val != null) {
        this.checarNombre(val);
      }
    },
    "tratamiento.maximoSesiones": function (val) {
      if (val != null) {
        this.crearArrayMinMax(this.tratamiento.minimoSessiones, val);
      }
    },

    "tratamiento.idCategoriaTratamiento": function (val) {
      if (val != null) {
        this.obtenerSubcategorias(val);
      }
    },

    "arrayZonaTodas.0.bonoIndividualOg": function (val) {
      if (val != null) {
        this.transformZonas(val, "bonoIndividualOg");
      }
    },
    "arrayZonaTodas.0.bonoTrimestral": function (val) {
      if (val != null) {
        this.transformZonas(val, "bonoTrimestral");
      }
    },
    "arrayZonaTodas.0.comisionBaseEspecialistas": function (val) {
      if (val != null) {
        this.transformZonas(val, "comisionBaseEspecialistas");
      }
    },
    "arrayZonaTodas.0.comisionBaseOG": function (val) {
      if (val != null) {
        this.transformZonas(val, "comisionBaseOG");
      }
    },
    "arrayZonaTodas.0.comisionMasBonoEspecialistas": function (val) {
      if (val != null) {
        this.transformZonas(val, "comisionMasBonoEspecialistas");
      }
    },
    "arrayZonaTodas.0.precio": function (val) {
      if (val != null) {
        this.transformZonas(val, "precio");
      }
    },
    "arrayZonaTodas.0.precioExtranjero": function (val) {
      if (val != null) {
        this.transformZonas(val, "precioExtranjero");
      }
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.debug = this.$localStorageService.getDebug();
    this.obtenerTiposFlujoFisico();
    this.llenarProveedoresERP();
    this.llenarClinicas();
    this.llenarCategorias();
    this.llenarZonas();
    this.llenarEspecialidades();
    this.llenarSesiones();
    this.llenarPonderacion();
    this.obtenerTipoDenticion();
  //  this.listarConsentimientos();
    this.obtenerEstatusCategorias();
    this.obtenerCategorias();
    this.obtenerSubcategorias();
  },
  computed: {
    loader: function () {
      return (
        this.loadingClinicas ||
        this.loadingCategorias ||
        this.loadingEspecialidades ||
        this.loadingTratamientos ||
        this.loadingGuardar
      );
    },
  },
};
</script>

<style scoped>
.scrollable-container-catalogo{
  overflow-y: auto; 
  max-height: 40em; 
}

.barras {
    border-width: 1px;
    border-style: solid;
    border-color: #c2e7ff;
    background: #ffffff;
    
   /*  margin-right: 3%;*/
    padding-right: 4%;
    padding-left: 1%;
    border-radius: 20px;
    text-align: left;
    align-items: center;
}

.btn-extra-small {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  line-height: 1.5;
}
.icon-boton {
  margin: auto;
  height: 20px;
  display: block;
  margin-right: 1px;
    }
.boton-inv, .boton-inv:hover {
        height: 40px;
        width: 40px;
        border-radius: 50rem;
        color:  var(--color-icono);
        background-color: white;
        border-color: white;
        filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));

    }

    .boton-inv:hover, .boton-inv:active {
        border-color: var(--color-icono);
    }

  .tabTxtSeleccionado{
  font-size: .9vw;
  color: #17A2B8;
  }

  .tabTxt{
    font-size: .9vw;
    color: #717171;
  }
.tabOpciones.seleccionado{
    border-style: solid;
    border-width: 1px;
    border-color: #90D3DD;
    border-radius: 10px;
    color: #17a2b8;
  
  }

  .tabOpciones:hover{
    font-weight: 600;
  }

.mginInputTrt {
  padding: 10px;
  width: 100%;
  font-weight: bolder !important;
}

.txtLeft {
  font-weight: bolder;
  text-align: left;
  margin-left: 10px;
}

.displayFlex {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  padding: 10px;
  padding-bottom: 25px;
  border-bottom: 2px solid #ddd;
}

.itmFlx {
  width: 48%;
  text-align: left;
}

.preCo {
  margin-top: 10px;
  font-size: 18px;
}

.btnClinicas {
  margin: 10px;
  display: flex;
  justify-content: flex-start;
}

.botonesSeleccion {
  margin-top: 10px;
  margin-bottom: 10px;
}

.btnsBottom {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.trtPadecimiento {
  padding: 10px;
  font-size: 15px;
  letter-spacing: 1px;
}

.custom-switch {
  text-align: left !important;
  line-height: 2.6 !important;
}
</style>

